import { render } from "./Appointments.vue?vue&type=template&id=5d98175a&scoped=true"
import script from "./Appointments.vue?vue&type=script&lang=js"
export * from "./Appointments.vue?vue&type=script&lang=js"

import "./Appointments.vue?vue&type=style&index=0&id=5d98175a&lang=scss&scoped=true"
import "./Appointments.vue?vue&type=style&index=1&id=5d98175a&lang=scss"
import "./Appointments.vue?vue&type=style&index=2&id=5d98175a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d98175a"]])

export default __exports__